import Abstract from "./abstract";
import {commonEventEmitter} from "../../commonEventEmitter";

export default class EmailRegistration extends Abstract {
  constructor(loginContainer, formSelector, api, errorView) {
    super(loginContainer, formSelector);

    this._errorView = errorView;

    this._api = api;

    this._location = window.location;

    this._captcha.type = `email-registration`;

    commonEventEmitter.on(`captcha.get`, this._onCaptchaGet);
    commonEventEmitter.on(`captcha.remove`, this._onCaptchaRemove);
  }

  sendFormToServer() {
    if (!this._captcha.token) return;

    const data = new FormData(this._form);

    data.set(`smart-token`, this._captcha.token);

    this._api.sendRegistrationEmail(data).then(this._processingServerResponse);
  }

  _onCaptchaRemove = () => {
    this._captcha.token = null;
  };

  _onCaptchaGet = (token, type) => {
    this._captcha.token = token ? token : null;

    if (type === this._captcha.type && (this._validateInput(`email`))) {
      this.sendFormToServer();
    }
  };

  _processingServerResponse(data) {
    super._processingServerResponse(data);

    if (data.code === 200) {
      if (this._errorView.isShowedError()) {
        this._errorView.hideError();
      }

      this._loginContainer.classList.add(`login__content--sent-mail`);
      this._loginContainer.classList.remove(`login__content--registration`);
    } else if (data.code === 409) {
      this._errorView.showError(`Такой e-mail уже существует, воспользуйтесь <a href="/site/password-restore">восстановлением пароля</a>`);
    } else if (data.code === 400) {
      this._errorView.showError(`E-mail указан не верно`);
    } else {
      this._errorView.showError(data.answer);
    }
  }

  changeFormSubmitStatus(evt) {
    super.changeFormSubmitStatus(evt);

    if (!this._validateInput(`email`)) {
      evt.preventDefault();
    } else {
      evt.preventDefault();
      this.sendFormToServer();
    }
  }
}
